/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { VwbGroupDescription } from './VwbGroupDescription';
import {
    VwbGroupDescriptionFromJSON,
    VwbGroupDescriptionFromJSONTyped,
    VwbGroupDescriptionToJSON,
} from './VwbGroupDescription';

/**
 * 
 * @export
 * @interface VwbGroupListResponse
 */
export interface VwbGroupListResponse {
    /**
     * 
     * @type {Array<VwbGroupDescription>}
     * @memberof VwbGroupListResponse
     */
    groups: Array<VwbGroupDescription>;
}

/**
 * Check if a given object implements the VwbGroupListResponse interface.
 */
export function instanceOfVwbGroupListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "groups" in value;

    return isInstance;
}

export function VwbGroupListResponseFromJSON(json: any): VwbGroupListResponse {
    return VwbGroupListResponseFromJSONTyped(json, false);
}

export function VwbGroupListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VwbGroupListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'groups': ((json['groups'] as Array<any>).map(VwbGroupDescriptionFromJSON)),
    };
}

export function VwbGroupListResponseToJSON(value?: VwbGroupListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'groups': ((value.groups as Array<any>).map(VwbGroupDescriptionToJSON)),
    };
}

